import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useCallback, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function ToolDropdown({
  Icon,
  tooltipTitle,
  children
}) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const handleOpenChange = useCallback(e => {
    setIsOpen(e.target.value);
  }, []);
  const shouldCloseOnClick = useCallback(evt => {
    var _menuRef$current;
    const target = evt.target;
    return (_menuRef$current = menuRef.current) !== null && _menuRef$current !== void 0 && _menuRef$current.contains(target) || target.closest('[data-dropdown-menu]') ? false : null;
  }, []);
  const renderButton = useCallback(buttonProps => /*#__PURE__*/_jsx(Tooltip, {
    title: tooltipTitle,
    children: /*#__PURE__*/_jsx(IconButton, Object.assign({}, buttonProps, {
      size: "small",
      use: "secondary",
      marginInlineStart: "0",
      children: /*#__PURE__*/_jsx(Icon, {})
    }))
  }), [Icon, tooltipTitle]);
  return /*#__PURE__*/_jsx(Dropdown, {
    Button: renderButton,
    open: isOpen,
    onOpenChange: handleOpenChange,
    closeOnMenuClick: false,
    shouldCloseOnClick: shouldCloseOnClick,
    popoverProps: {
      usePortal: false
    },
    children: /*#__PURE__*/_jsx("div", {
      ref: menuRef,
      children: children
    })
  });
}